import { Edit, SimpleForm, TextInput, ResourceContextProvider, BooleanInput } from 'react-admin';
import { Box, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

export const MaterialCategoryEdit = () => {
  const navigate = useNavigate();

  return (
    <ResourceContextProvider value="materials/categories">
      <Box sx={{ p: 3 }}>
        <Box sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box
            component="button"
            onClick={() => navigate('/configuration/material-categories')}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              border: '1px solid #ddd',
              borderRadius: 1,
              px: 2,
              py: 1,
              bgcolor: 'background.paper',
              cursor: 'pointer',
              '&:hover': {
                bgcolor: 'grey.100',
              },
              transition: 'all 0.2s ease',
            }}
          >
            <ArrowBackIcon fontSize="small" />
            <Typography variant="body2">Back to Material Categories</Typography>
          </Box>
        </Box>

        <Edit redirect="show">
          <SimpleForm spacing={2}>
            <Typography variant="h6" gutterBottom>
              Edit Material Category
            </Typography>
            <TextInput
              source="name"
              label="Category Name"
              required
              fullWidth
              helperText="Choose a descriptive name for this material category"
            />
            <TextInput
              source="description"
              label="Description"
              fullWidth
              multiline
              rows={3}
            />
            <BooleanInput
              source="isActive"
              label="Active"
              defaultValue={true}
            />
          </SimpleForm>
        </Edit>
      </Box>
    </ResourceContextProvider>
  );
};
